import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const English = () => {
  return (
    <SvgIcon height={15} width={24}>
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rechteck_245"
            data-name="Rechteck 245"
            width="24"
            height="15"
            rx="2"
            transform="translate(596 20)"
            fill="#021e6d"
          />
        </clipPath>
      </defs>
      <g transform="translate(-563 -20)">
        <g
          id="Gruppe_maskieren_13"
          data-name="Gruppe maskieren 13"
          transform="translate(-33)"
          clip-path="url(#clip-path)"
        >
          <rect
            id="Rechteck_247"
            data-name="Rechteck 247"
            width="24"
            height="15"
            transform="translate(596 20)"
            fill="#021e6d"
          />
          <g id="Gruppe_365" data-name="Gruppe 365">
            <rect
              id="Rechteck_241"
              data-name="Rechteck 241"
              width="3"
              height="33"
              transform="matrix(0.454, -0.891, 0.891, 0.454, 592.479, 21.096)"
              fill="#fff"
            />
            <rect
              id="Rechteck_240"
              data-name="Rechteck 240"
              width="1.2"
              height="18"
              transform="matrix(0.454, -0.891, 0.891, 0.454, 607.298, 27.011)"
              fill="#da0025"
            />
            <rect
              id="Rechteck_242"
              data-name="Rechteck 242"
              width="1.2"
              height="16"
              transform="matrix(0.454, -0.891, 0.891, 0.454, 593.93, 21.205)"
              fill="#da0025"
            />
          </g>
          <g
            id="Gruppe_366"
            data-name="Gruppe 366"
            transform="translate(624.55 19.736) rotate(126)"
          >
            <rect
              id="Rechteck_241-2"
              data-name="Rechteck 241"
              width="3"
              height="33"
              transform="matrix(-0.454, 0.891, -0.891, -0.454, 31.402, 14.982)"
              fill="#fff"
            />
            <rect
              id="Rechteck_240-2"
              data-name="Rechteck 240"
              width="1.2"
              height="18"
              transform="matrix(-0.454, 0.891, -0.891, -0.454, 16.583, 9.066)"
              fill="#da0025"
            />
            <rect
              id="Rechteck_242-2"
              data-name="Rechteck 242"
              width="1.2"
              height="16"
              transform="matrix(-0.454, 0.891, -0.891, -0.454, 29.951, 14.873)"
              fill="#da0025"
            />
          </g>
          <g
            id="Gruppe_368"
            data-name="Gruppe 368"
            transform="translate(635.5 -581) rotate(90)"
          >
            <rect
              id="Rechteck_243"
              data-name="Rechteck 243"
              width="33"
              height="5"
              transform="translate(592 25)"
              fill="#fff"
            />
            <rect
              id="Rechteck_244"
              data-name="Rechteck 244"
              width="33"
              height="3"
              transform="translate(592 26)"
              fill="#da0025"
            />
          </g>
          <g id="Gruppe_367" data-name="Gruppe 367">
            <rect
              id="Rechteck_243-2"
              data-name="Rechteck 243"
              width="33"
              height="5"
              transform="translate(592 25)"
              fill="#fff"
            />
            <rect
              id="Rechteck_244-2"
              data-name="Rechteck 244"
              width="33"
              height="3"
              transform="translate(592 26)"
              fill="#da0025"
            />
          </g>
        </g>
        <rect
          id="Rechteck_248"
          data-name="Rechteck 248"
          width="15"
          height="3"
          transform="translate(576.5 20) rotate(90)"
          fill="#da0025"
        />
      </g>
    </SvgIcon>
  );
};

export default English;
